import * as jwt from 'jsonwebtoken'
import Cookies from 'js-cookie'
import { COOKIES_TOKEN_KEY } from '@/constants'
import { UserIdentityTokenPayload } from '@/types'

export const getAuthXToken = (): { value: string, payload: UserIdentityTokenPayload } => {
  const token = Cookies.get(COOKIES_TOKEN_KEY)

  if (!token) {
    return null
  }

  const payload = jwt.decode(token) as any

  if (!payload || Date.now() >= payload.exp * 1000) {
    Cookies.remove(COOKIES_TOKEN_KEY)
    return null
  }

  return { value: token, payload }
}
